<div class="content">
	<licenses-table [orgId]="orgId" [myAccount]="myAccount"></licenses-table>
</div>
